<script setup>
import { useAttrs } from 'vue';

const attrs = useAttrs();
const src = '/favicon-96x96.png';
</script>

<template>
  <img v-bind="attrs" :src="src" alt="Logo" />
</template>
